
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"198","height":"65","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M197.5.5H.5v64h197V.5z","stroke":"#EAEAEA","fill":"#FFF"}}),_c('path',{attrs:{"fill":"#779EB7","d":"M32 16.146h107.2V10.11H32zM32 27.716h53.6V21.68H32zM10 28h18V10H10z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M23.616 14l-6.693 6.665-2.538-2.534L13 19.513l3.923 3.916L25 15.382z"}}),_c('g',[_c('path',{attrs:{"fill":"#779EB7","d":"M32 43.146h107.2V37.11H32zM32 54.716h53.6V48.68H32zM10 55h18V37H10z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M23.616 41l-6.693 6.665-2.538-2.534L13 46.513l3.923 3.916L25 42.382z"}})])])])
          )
        }
      }
    